import { useMemo } from 'react';

// Password requirements configuration
export const PASSWORD_REQUIREMENTS = [
  {
    label: "Minumum of 8 characters",
    regex: /^.{8,}$/,
    met: false
  },
  {
    label: "At least one uppercase letter (A-Z)",
    regex: /[A-Z]/,
    met: false
  },
  {
    label: "At least one lowercase letter (a-z)",
    regex: /[a-z]/,
    met: false
  },
  {
    label: "At least one number (0-9)",
    regex: /[0-9]/,
    met: false
  },
  {
    label: "At least one special character (!@#$%^&*)",
    regex: /[!@#$%^&*]/,
    met: false
  }
];

// Check password against all requirements
export const checkPasswordRequirements = (password) => {
  return PASSWORD_REQUIREMENTS.map(req => ({
    ...req,
    met: req.regex.test(password)
  }));
};

// Custom hook for password requirements
export const usePasswordRequirements = (password) => {
  // Get current password requirements status
  const currentRequirements = useMemo(() => 
    checkPasswordRequirements(password),
    [password]
  );

  // Check if all requirements are met
  const allRequirementsMet = useMemo(() => 
    currentRequirements.every(req => req.met),
    [currentRequirements]
  );

  return {
    requirements: currentRequirements,
    allRequirementsMet,
    checkRequirements: checkPasswordRequirements
  };
};

// Utility function to validate password without hooks (for non-React contexts)
export const validatePassword = (password) => {
  const requirements = checkPasswordRequirements(password);
  const allMet = requirements.every(req => req.met);
  
  return {
    isValid: allMet,
    requirements,
    allRequirementsMet: allMet
  };
};
